<script lang="ts">
	import { getDeviceSettings } from 'src/stores/device-runtime/status-selectors';
	//Hooks
	import { onMount } from 'svelte';
	//Services
	import { format } from 'svelte-i18n';
	import { postReq } from 'src/services/http';
	//Stores
		//Helpers
	import { real_id, real_id_z } from 'src/helpers/interface_helpers';
	import { onSettingsResponse } from 'src/helpers/device_settings_helpers';
	//Types
	import type { SettingRequest } from 'src/types/requests/settings/setting';
	//Design system components
	import { Button, Radio, Text } from '@Shelly/shelly-design-system';

	$: settingsStore = getDeviceSettings(id);
	export let device;

	const id = real_id(device.id);

	const inputOptions = ['no_action', 'open', 'close'];
	const _input_options_i18n = [
		$format('alarm_state_no_action', { default: 'No action' }),
		$format('alarm_state_open', { default: 'Open' }),
		$format('alarm_state_close', { default: 'Close' }), //Todo: discuss working types!!!
	];

	let settings = $settingsStore,
		inputTypes = {},
		deviceChannel = device.channel,
		setting = '91',
		loading = false,
		cache;

	onMount(() => {
		inputTypes[deviceChannel] = settings[`Configuration:0`][setting];
		cache = Object.assign({}, { ...inputTypes });
	});

	const setInputType = (value) => {
		inputTypes[deviceChannel] = value;
	};
	const sentRequest = async () => {
		if (JSON.stringify(cache) !== JSON.stringify(inputTypes)) {
			loading = true;

			const params = {
				id: real_id_z(device.id), //gateway's id
				a: 'call', //inclusion command
				cc: 'Configuration', //command class
				m: 'set', //method
				ep: 0, //endpoint
				params: JSON.stringify([{ parameter: +setting, value: +inputTypes[deviceChannel] }]), //parameters parameter - setting index, value - setting value
			};
			const res: SettingRequest = await postReq(`/fast/device/zw`, {
				...params,
			});

			if (res.isok) {
				params.m = 'get'; //override method
				params.params = JSON.stringify([+setting]); //override params
				const res_get: SettingRequest = await postReq(`/fast/device/zw`, {
					...params,
				});
				cache = Object.assign({}, { ...inputTypes });
			}
			await onSettingsResponse(res, device);
			loading = false;
		}
	};
</script>

<Text element="h2" styleType="body-small" class="mb-s">
	{$format('description_device_action_alarm', {
		default: 'Select device action if alarm was detected.',
	})}
</Text>

{#each inputOptions as option, index}
	<Radio
		size="m"
		selected={inputOptions[inputTypes[deviceChannel]]}
		value={option}
		on:click={() => setInputType(index)}
		id="radio-01x1pqj"
	>
		{_input_options_i18n[index]}
	</Radio>
{/each}

<Button class="mt-s" {loading} size="m" width="full" on:click={sentRequest}>
	{$format('button_save')}
</Button>
